// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xGru","content":"styles_content__1oqEn","tableWrap":"styles_tableWrap__39v5U"};